import firebase from 'firebase/app'
import 'firebase/messaging'
import Matrix from './scripts/Matrix'

export const initializeFirebase = () => {
  const firebaseConfig = {
    apiKey: "AIzaSyDih8OvEjJeGqF23aCSZzhJgsdAvsEWxZo",
    authDomain: "tebinja-2ceb6.firebaseapp.com",
    databaseURL: "https://tebinja-2ceb6.firebaseio.com",
    projectId: "tebinja-2ceb6",
    storageBucket: "tebinja-2ceb6.appspot.com",
    messagingSenderId: "732397041688",
    appId: "1:732397041688:web:40ed4c913127c687462b6d",
    measurementId: "G-YVCQ7ELBMV"
  };
  firebase.initializeApp(firebaseConfig)
}

export const askForPermission = (MatrixClient) => {
  try {
    const messaging = firebase.messaging()

    messaging.usePublicVapidKey('BOB6NAMu_wmzlEdzUkgqCLlQ8iK8qrigF6-EpCWpe3imFR_S7XKmIgb5Scq_DPtDBMm8akbDf4VzEuGJ-p4MOsI')

    messaging.requestPermission()
      .then(() => {
        messaging.getToken().then((refToken) => {

          console.log(refToken, '1----------------------------------------')
          Matrix.setPusher(refToken)
        })
        messaging.onTokenRefresh(() => {
          messaging.getToken().then((refToken) => {
            console.log(refToken, '----------------------------------------')
            Matrix.setPusher(refToken)
          })
        })

      })
      .catch(err => console.log(err))

    messaging.onMessage(payload => {
      console.log(payload)
    })
  } catch (e) {
    console.log(e)
  }
}